import React, { ChangeEvent, useState, FC } from 'react'
import { FileInputViewModel } from '@sitecore-jss/sitecore-jss-forms'
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'
import { useTranslation } from 'react-i18next';

const FileUpload: FC<ValueFieldProps<FileInputViewModel>> = (props) => {
  const { t } = useTranslation();
  const { field, isValid, fieldValidationErrorsComponent, onChange } = props

  const [fileName, setFileName] = useState<string[]>([])

  const FieldValidationErrors = fieldValidationErrorsComponent

  const id = field.valueField.id
  const name = field.valueField.name

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files ?? [];
    let List: string[] = []
    for (let i = 0; i < files?.length; i++) {
      List.push(files[i].name)
    }
    setFileName(List)
    if (files.length > 0 && files.length <= 2) {
      for (let i = 0; i < files.length; i++) {
        let filePath = files[i].name
        let fileExtension = filePath
          .split('.')
          [filePath.split('.').length - 1].toLowerCase()
        onChange(field.valueField.name, e.target.value, isValid, [])
        if (
          !(
            fileExtension === 'pdf' ||
            fileExtension === 'png' ||
            fileExtension === 'jpeg' ||
            fileExtension === 'jpg' ||
            fileExtension === 'bmp'
          )
        ) {
          onChange(field.valueField.name, e.target.value, isValid, [
            'You can only upload the following file types : png,jpg,bmp,jpeg,pdf',
          ])
        } else {
          onChange(field.valueField.name, e.target.value, isValid, [])
          if (files[i].size > 5000000) {
            onChange(field.valueField.name, e.target.value, isValid, [
              'You can only upload file size upto 5MB',
            ])
          } else {
            onChange(field.valueField.name, e.target.value, isValid, [])
          }
        }
      }
    } else if (files.length === 0) {
      onChange(field.valueField.name, e.target.value, isValid, [])
    } else {
      onChange(field.valueField.name, e.target.value, isValid, [
        'You can only upload 2 files',
      ])
    }
  }
  return (<>
    <div >
        {field.model.title} 
        </div>
      <div className="file-upload-container">
        
        <label htmlFor={id}>{t('ChooseFile')}</label>
        <input
          type="file"
          className={fileName.length > 1 ? 'multiple-files' : ''}
          accept={field.model.allowedContentTypes}
          multiple={field.model.isMultiple}
          onChange={handleChange}
          id={id}
          name={name}
        />
        </div>
        <div className="selected-files">
          {fileName.length > 0 &&
            fileName.map((item, index) => {
              return (
                <p key={index} className="file-name">
                  {item}
                </p>
              )
            })}  
            {fileName.length == 0 &&    (
                <p  className="file-name">
                  {t("NoFileChosen")}
                </p>
              ) 
          }
      </div>

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  )
}

export default FileUpload
